var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50815 8.52314V5.62012H5.40602C5.23837 6.47661 5.13467 7.44513 5.11206 8.52314H8.50815Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5076 4.66118V0.875C7.35574 1.15439 6.25482 2.43431 5.63159 4.66118H8.5076Z",
    fill: "#E53323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12825 9.47949H0.615723C0.675532 10.4823 0.922743 11.4521 1.34138 12.3506H4.4064C4.24515 11.4666 4.15138 10.5051 4.12825 9.47949Z",
    fill: "#E53323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.615723 8.52314H4.12723C4.14803 7.48539 4.24121 6.51288 4.40407 5.62012H1.35647C0.92878 6.52765 0.676221 7.50842 0.615723 8.52314Z",
    fill: "#E53323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49194 0.878906V4.6611H12.3594C12.1236 3.82726 11.8411 3.19989 11.5805 2.74179C10.9977 1.71766 10.2698 1.07344 9.49194 0.878906Z",
    fill: "#E53323"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50804 9.47949H5.11304C5.13886 10.5957 5.2487 11.5462 5.40592 12.3506H8.50808L8.50804 9.47949Z",
    fill: "#004899"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4418 2.27973C12.8304 2.96264 13.143 3.76305 13.3762 4.66238H16.1099C15.7773 4.15122 15.3836 3.67178 14.9322 3.23281C14.0174 2.34331 12.9318 1.68419 11.7495 1.28418C11.9987 1.57544 12.2301 1.90766 12.4418 2.27973Z",
    fill: "#E53323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.887 8.52314C12.8609 7.39205 12.7483 6.43137 12.5878 5.62012H9.49194V8.52314H12.887Z",
    fill: "#004899"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3953 13.3076C13.1616 14.2262 12.8452 15.0425 12.4496 15.7366C12.2427 16.0995 12.0168 16.4241 11.7739 16.7097C12.947 16.3089 14.0242 15.6526 14.9328 14.7691C15.3936 14.3211 15.794 13.8307 16.1309 13.3076H13.3953Z",
    fill: "#004899"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61424 4.6613C4.84712 3.75575 5.16067 2.9504 5.55171 2.26439C5.75863 1.90142 5.98452 1.57669 6.22746 1.29102C5.05437 1.69179 3.9771 2.34813 3.06841 3.2317C2.61697 3.67067 2.22327 4.15011 1.89062 4.66127L4.61424 4.6613Z",
    fill: "#004899"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5872 5.62012C13.7521 6.51291 13.848 7.4851 13.8714 8.52314H17.3839C17.3234 7.50842 17.0708 6.52765 16.6431 5.62012H13.5872Z",
    fill: "#E53323"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55902 15.7223C5.16581 15.0313 4.85055 14.22 4.6165 13.3076H1.87061C2.20755 13.8307 2.60791 14.3211 3.06867 14.7691C3.98343 15.6586 5.06903 16.3177 6.25127 16.7177C6.00213 16.4265 5.7707 16.0943 5.55902 15.7223Z",
    fill: "#E53323"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49194 9.47949V12.3506H12.6004C12.7644 11.502 12.8659 10.5442 12.8881 9.47949H9.49194Z",
    fill: "#E53323"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3845 9.47949H13.8731C13.8526 10.5049 13.7613 11.4666 13.6021 12.3506H16.6589C17.0775 11.452 17.3247 10.4823 17.3845 9.47949Z",
    fill: "#E53323"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49194 13.3076V17.1257C10.6494 16.845 11.7556 15.5544 12.3772 13.3076H9.49194Z",
    fill: "#E53323"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50678 17.1217V13.3076H5.63037C5.86803 14.1575 6.15435 14.7951 6.41833 15.259C7.00107 16.283 7.72892 16.9272 8.50678 17.1217Z",
    fill: "#E53323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.e4bf2f73ac328b7a22cd9f657511f5a6.svg";
export { ForwardRef as ReactComponent };